export default "__VITE_ASSET__e3d45c96__"